import { createContext } from 'react';

// Type definitions
export interface UserData {
  sub?: string;
  email?: string;
  isRegisteredAmos?: boolean;
  [key: string]: any;
}

export interface Auth0User {
  userInfo?: {
    email?: string;
    [key: string]: any;
  };
  [key: string]: any;
}

export interface ClientData {
  type?: string;
  dependents?: any[];
  [key: string]: any;
}

export interface CountryOption {
  label: string;
  value: string;
}

export interface CountryDdiOption {
  label: string;
  value: string;
  onlySort: string;
}

export interface GeneralContextType {
  userData: UserData | null;
  client: ClientData | null;
  dependents: any[] | null;
  adults: any | null;
  amosToken: string | null;
  amosRefreshToken: string | null;
  amosClient: string | null;
  isLogged: boolean;
  clientCode: string | null;
  refreshClientAndDependents: boolean;
  country: CountryOption[];
  countryDdi: CountryDdiOption[];
  fetchAmosCountry: (idiom: string) => Promise<void>;
  setRefreshClientAndDependents: (value: boolean) => void;
  loginAmos: () => Promise<void>;
  logoutAmos: () => Promise<void>;
  setIsLoading: (value: boolean) => void;
  fetchClientAndDependents: () => Promise<void>;
  fetchAdults: () => Promise<void>;
  clearAmosToken: () => Promise<void>;
  clearServiceWorkerCache: () => Promise<boolean>;
  setUserData: (data: UserData | null) => void;
  reFreshClientToken: () => Promise<void>;
  ispopup: boolean;
  setIspopup: (value: boolean) => void;
  adultClientId: string | null;
  adultClientToken: string | null;
  adultClientCode: string | null;
  adultRefreshToken: string | null;
  reFreshAdultClientToken: () => Promise<void>;
}

export const GeneralContext = createContext<GeneralContextType>({
  userData: null,
  client: null,
  dependents: null,
  adults: null,
  amosToken: null,
  amosRefreshToken: null,
  amosClient: null,
  isLogged: false,
  clientCode: null,
  refreshClientAndDependents: false,
  country: [],
  countryDdi: [],
  fetchAmosCountry: async () => {},
  setRefreshClientAndDependents: () => {},
  loginAmos: async () => {},
  logoutAmos: async () => {},
  setIsLoading: () => {},
  fetchClientAndDependents: async () => {},
  fetchAdults: async () => {},
  clearAmosToken: async () => {},
  clearServiceWorkerCache: async () => false,
  setUserData: () => {},
  reFreshClientToken: async () => {},
  ispopup: false,
  setIspopup: () => {},
  adultClientId: null,
  adultClientToken: null,
  adultClientCode: null,
  adultRefreshToken: null,
  reFreshAdultClientToken: async () => {},
});
